declare var cms: any;

export function openTopic(helpTopicId: string) {
    cms.help.GuidedAssistant.getInstance()._openHelpTopic(helpTopicId);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/help/help.ts
 **/